module.exports = __webpack_public_path__ + "static/img/CumminsLogo-black.a8ac891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CumminsLogo-black.png
// module id = 9/6a
// module chunks = 1